import { useHome } from "./useHome";

//images
import { Telecontrol } from "@assets";

//components
import { Button } from "@atoms";

export const Home = () => {
  const helper = useHome();

  return (
    <div className="h-[60vh] w-full">
      <div className="h-[100%] flex justify-center items-center">
        <img src={Telecontrol} alt="" />
      </div>
      <div className="border-t border-[#D8DCDE] flex flex-col gap-[20px]">
        <Button onClick={helper.goToContultOs}>Consultar OS</Button>
        <Button onClick={helper.goToPreOs}>Pré-OS</Button>
        <Button onClick={helper.goToPostByCep}>Buscar Posto</Button>
        <Button onClick={helper.goToPosts}>Consultar Posto</Button>
      </div>
    </div>
  );
};
